"use client"

import Hero from "../Images/Hero.png"

const Home = () => {
  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: "Sriram Gandrothu - Portfolio",
          text: "Check out my portfolio🩷\n\n",
          url: "https://sriramgandrothu.netlify.app/",
        })
        console.log("Content shared successfully")
      } catch (error) {
        console.error("Error sharing content:", error)
      }
    } else {
      alert("Web Share API is not supported in your browser.")
    }
  }

  return (
    <section
      className="min-h-screen px-[9%] py-[15rem] flex justify-center items-center flex-col lg:flex-row"
      id="home"
    >
      <div className="order-2 lg:order-1 flex-1 lg:flex-[1.5]">
        <h3 className="text-[2.6rem] md:text-[3.2rem] font-bold">Hi, Myself</h3>
        <h1 className="text-[5rem] md:text-[5.6rem] font-bold leading-[1.3] font-dancing">Sriram Gandrothu</h1>
        <div className="text">
          <h3 className="text-[2.6rem] md:text-[3.2rem] font-bold mb-8">
            The <span className="relative"></span>
          </h3>
        </div>
        <p className="text-[1.6rem] mb-12">
          I am a driven and adaptable individual, constantly seeking out fresh opportunities to grow. Fueled by a love
          for learning, I am committed to producing top-notch outcomes. With an optimistic outlook and a focus on
          growth, I am prepared to make a significant impact and accomplish remarkable feats.
        </p>

        <div className="flex gap-6 mb-12">
          {[
            { href: "https://github.com/sriramgandrothu", icon: "fa-brands fa-github" },
            { href: "https://www.linkedin.com/in/sriramgandrothu/", icon: "fa-brands fa-linkedin" },
            {
              href: "https://instagram.com/sriramgandrothu?utm_source=qr&igshid=MzNlNGNkZWQ4Mg==",
              icon: "fa-brands fa-instagram",
            },
            { href: "https://wa.me/7842713943", icon: "fa-brands fa-whatsapp" },
            { href: "mailto:sriramgandrothu@gmail.com", icon: "fa-regular fa-envelope" },
          ].map((social, index) => (
            <a
              key={index}
              href={social.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex justify-center items-center w-16 h-16 bg-transparent border-2 border-accent rounded-full text-[2rem] text-accent transition-all duration-300 hover:bg-accent hover:text-bg-secondary hover:shadow-[0_0_1rem_#59b2f4]"
            >
              <i className={social.icon}></i>
            </a>
          ))}
        </div>

        <div className="flex flex-row gap-4">
          <a
            href="https://drive.google.com/file/d/1r-y09MpuRWBuI_0QkIRNZEBOkbhZHXCn/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-[2.8rem] py-4 bg-accent rounded-[4rem] shadow-[0_0_1rem_#59b2f4] text-[1.6rem] text-bg-primary font-semibold tracking-[0.1rem] transition-shadow duration-300 hover:shadow-none text-center"
          >
            Check Resume
          </a>
          <button
            onClick={handleShare}
            className="inline-block px-[2.8rem] py-4 bg-accent rounded-[4rem] shadow-[0_0_1rem_#59b2f4] text-[1.6rem] text-bg-primary font-semibold tracking-[0.1rem] transition-shadow duration-300 hover:shadow-none"
          >
            Share
          </button>
        </div>
      </div>

      <div className="order-1 lg:order-2 flex-1 flex justify-center mb-10 lg:mb-0">
        <div className="relative">
          <img
            src={Hero || "/placeholder.svg"}
            alt="Sriram Gandrothu"
            className="w-[300px] h-[300px] md:w-[350px] md:h-[350px] lg:w-[400px] lg:h-[400px] rounded-full object-cover animate-float shadow-[0_0_2rem_rgba(89,178,244,0.3)]"
          />
        </div>
      </div>
    </section>
  )
}

export default Home
